import React, { useState } from 'react'
import Activity from '../../components/Activity'
import DementiaForm from './DementiaForm'
import styles from './DementiaReport.module.css'
import dementia from './images/DementiaBrainPatterns.jpg'

const DementiaReport = () => {
  const [result, setResult] = useState(null)
  const [error, setError] = useState('')
  const [fileNum, setFileNum] = useState(null)

  const getResultMessage = () => {
    const baseText = `Based on the analysis, patient ${fileNum}`
    const resultText = result ? 'HAS DEMENTIA' : 'DOES NOT HAVE DEMENTIA'
    return (
      <p>
        {baseText} <span className={result ? styles.highlightPositive : styles.highlightNegative}>{resultText}</span>
      </p>
    )
  }

  return (
    <div className='report-tab'>
      <div className={styles.uploadPanel}>
        <div className='dashboard-cards p-4'>
          <DementiaForm setResult={setResult} setError={setError} setFileNum={setFileNum} />
        </div>
      </div>

      <div className={styles.resultPanel}>
        {(result !== null || error) && (
          <div className={styles.resultContainer}>
            {error ? (
              <div className={styles.errorMessage}>
                <p>{error}</p>
              </div>
            ) : (
              <div className='dashboard-cards p-4'>
                <div className={styles.resultMessage}>{getResultMessage()}</div>
                <hr className='my-4' />
                <img src={dementia} alt='Brain Scan Pattern' className={styles.brainScanImage} />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default DementiaReport
